import React from "react";
import SwitchSelector from "react-switch-selector";

const Toggler = ({options, initialSelectedIndex, onChangeHandler, name}) => (
  <div className="switch-toggler">
    <SwitchSelector
      onChange={onChangeHandler}
      options={options}
      initialSelectedIndex={options.findIndex(({value}) => value === initialSelectedIndex)}
      backgroundColor={"#E6ECF1"}
      selectedBackgroundColor={"#3BC98D"}
      fontColor={"#000"}
      selectedFontColor={"#FFFFFF"}
      name={name}
    />
  </div>
);

export default Toggler;
